import thengilPic from "@/public/images/artists/thengil.png";
import { Artist } from "@/types/types";

export const thengil = {
  id: "196",
  name: "Thengil",
  image: thengilPic,
  description: `Thengil's growl emerges as a low, sonorous hymn of obliteration—a dark melody carved from flame and fury, echoing like clashing steel against a storm-lashed fjord.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fthengil-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Growl", "Gritty", "Rock"],
      secondary: ["Experimental", "Scream"],
    },
    pitchRange: {
      categories: {
        low: "Bass",
        high: "Mid",
      },
      specific: {
        low: 44,
        high: 68,
      },
      sweetSpot: 56,
    },
  },
} as const satisfies Artist;
